import { createFeatureSelector, createSelector, select, Store } from '@ngrx/store'
import { identity, negate } from 'lodash-es'
import { distinctUntilChanged, filter, map, skipUntil } from 'rxjs/operators'
import * as fromAuth from './auth.reducer'

export const selectAuthState = createFeatureSelector<fromAuth.AuthState>(fromAuth.authFeatureKey)

export const selectAuthReady = createSelector(selectAuthState, (auth) => auth.ready)
export const selectAuthUser = createSelector(selectAuthState, (auth) => auth.user)
export const selectAuthorized = createSelector(selectAuthState, (auth) => !!auth.user)

function skipUntilAuthReady<T>(store: Store) {
  return skipUntil<T>(store.pipe(select(selectAuthReady), filter(identity)))
}

export const isAuthorized = (store: Store) => store.pipe(select(selectAuthorized), skipUntilAuthReady(store))

export const isAnonymous = (store: Store) =>
  store.pipe(select(selectAuthorized), map(negate(identity)), skipUntilAuthReady<boolean>(store))

export const canSeeApp = (appId: string) => (store: Store) =>
  store.pipe(
    select(selectAuthUser),
    skipUntilAuthReady(store),
    map((user) => user?.partners.some((p) => p.apps.some((app) => app._id === appId))),
    distinctUntilChanged()
  )
